<template>
  <div>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="line-height: 1.5"
    >
      <tbody>
        <tr>
          <td style="vertical-align: top;">
          </td>
          <!-- Info column -->
          <td style="vertical-align: top;">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              role="presentation"
            >
              <tbody>
                <!-- Name and job fields -->
                <tr>
                  <td>
                    <span>{{ mainFields[0].value }}</span><br />
                    <span>{{ mainFields[1].value }}</span><br />
                    <span>{{ mainFields[2].value }}</span><br />
                    <span>{{ mainFields[3].value }}</span><br />
                    <span>{{ mainFields[4].value.text }}</span><br />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from './emailTemplate'

export default {
  extends: EmailTemplate
}
</script>
